import styled from "styled-components";
import { colors, types } from "../../../libs/themes";

export const GridWrapper = styled.div`
  width: 100%;
  padding: 0px 24px 24px 24px;
  box-sizing: border-box;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const TopBorder = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.background.dray80};
  margin-bottom: 10px;

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  background: transparent;
  width: 100%; 
  @media (max-width: 600px) {
    flex-direction: column;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const RowDivider = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${colors.background.dray80};
  margin: 6px 0;

  @media (max-width: 768px) {
    margin: 12px 0;
  }
`;

export const ContentWrapper = styled.div`
  padding: 0px 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.div`
 ${types.headers.item};
  line-height: normal;
  color: ${({ theme }) => theme.cardText};
  margin-bottom: 4px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

 @media (max-width: 992px){
    font-size:  ${types.headers.xSmall};
  }
  @media (max-width: 768px) {
    font-size: ${types.headers.xSmall};
  }
`;
// export const RatingAndDirectorBlock = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 8px;
//   margin-bottom: 8px; 
// `;

export const RatingAndDirectorBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px; /* space before TrailerLink */

  & > div:first-child {
    margin-bottom: 0; /* No gap between StarRating and DirectorRow */
  }
`;


export const DirectorRow = styled.div`
${types.headers.normal};
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colors.background.black};
  margin-bottom: auto;
  flex-wrap: wrap;

  span {
    font-weight: 400;
    margin-left: 5px;
  }

  @media (max-width: 768px) {
    font-size: 13px;
    margin-top: 4px;
  }
`;

export const TrailerLink = styled.div`
  ${types.body.mediumSubtitle};
  color: ${({ theme }) => theme.cardText};
  font-weight:500;
  cursor: pointer;
  align-self: flex-start;
  margin-top: auto;
  text-decoration: underline;

  @media (max-width: 768px) {
    margin-top: 6px;
  }
`;
